import { Input } from "@nextui-org/react";
import React from "react";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}) => {
  return (
    <div className="flex justify-center grow flex-1 items-center">
      <div className="w-full max-w-96">
        <Input
          className="grow max-w-96 rounded-xl bg-[#F4F4F5]"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};
